import React from 'react';

import DatePickerLib from 'react-datepicker';

const propTypes = {};

const ExampleCustomInput = React.forwardRef(({ value, onClick, onChange, placeholder }, ref) => (
  <input
    value={value}
    className='react-datepicker-custom-input'
    onClick={onClick}
    onChange={onChange}
    placeholder={placeholder}
    ref={ref}
  />
));

const DatePicker = (props) => {
  //! State
  const dateFormat = props.showTimeInput ? 'MM/dd/yyyy h:mm aa' : undefined;

  //! Function

  //! Render
  return (
    <DatePickerLib
      customInput={<ExampleCustomInput />}
      showMonthDropdown
      dateFormat={dateFormat}
      {...props}
    />
  );
};

DatePicker.propTypes = propTypes;
export default React.memo(DatePicker);
